import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";

export const fields: FilterFieldConfig[] = [
    { key: "billingNumber", label: "Billing Number", type: "text", default: "" },
    { key: "fromDate", label: "Start Date", type: "range", default: "", inputType: "date" },
    { key: "toDate", label: "End Date", type: "range", default: "", inputType: "date" },
    { key: "projectName", label: "Project", type: "text", default: "" },
    { key: "amount", label: "Amount", type: "range", default: "", inputType: "number" },
    { key: "notes", label: "Notes", type: "text", default: "" },
    {
        key: "approver",
        label: "Approver",
        type: "select",
        default: "",
        options: [],
    },
    {
        key: "decision",
        label: "Status",
        type: "select",
        default: "All",
        options: [
            { value: "All", label: "All" },
            { value: "Submitted", label: "Submitted" },
            { value: "Approved", label: "Approved" },
            { value: "Rejected", label: "Rejected" },
        ],
    },
    {
        key: "billed",
        label: "Billed",
        type: "select",
        default: "All",
        options: [
            { value: "All", label: "All" },
            { value: "yes", label: "Yes" },
            { value: "", label: "No" },
        ],
    },
    { key: "notifiedBy", label: "Notified By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "notifiedAt", label: "Notified At", type: "range", default: "", inputType: "date" },
    { key: "approvalTime", label: "Decision Time", type: "range", default: "", inputType: "date"},
    { key: "approverNotes", label: "Approver Notes", type: "text", default: "" },
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no",
        options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function BillingFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
